import { FloorItemModel } from "./floorItem.model";

export class BuildingModel {
  constructor(
    public id: string,
    public name: string,
    public floors: FloorItemModel[],
    public isGraphic: boolean,
    public isExported: boolean
  ) {}
}
